
import React, { useState } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import DashboardGeral from './pages/DashboardGeral'
import CRMDashboard from './pages/CRMDashboard'
import BaseInsumos from './pages/BaseInsumos'
import Orcamentos from './pages/Orcamentos'
import Contratos from './pages/Contratos'
import Funcionarios from './pages/Funcionarios'
import PlanejamentoObras from './pages/PlanejamentoObras'
import DiarioObra from './pages/DiarioObra'
import Compras from './pages/Compras'
import Financeiro from './pages/Financeiro'
import Usuarios from './pages/Usuarios'
import Login from './pages/Login'
import Sidebar from './components/Sidebar'

function App() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed)
  }

  // Verifica se está autenticado
  React.useEffect(() => {
    const authStatus = localStorage.getItem('gestpro_auth')
    setIsAuthenticated(authStatus === 'true')
  }, [])

  const handleLogin = () => {
    localStorage.setItem('gestpro_auth', 'true')
    setIsAuthenticated(true)
  }

  const handleLogout = () => {
    localStorage.removeItem('gestpro_auth')
    setIsAuthenticated(false)
  }

  // Bloquear acesso sem login - sempre redirecionar para login se não autenticado
  if (!isAuthenticated) {
    return (
      <>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 5000,
            style: { background: '#363636', color: '#fff' },
            success: { style: { background: '#10b981' } },
            error: { style: { background: '#ef4444' } }
          }}
        />
        <Login onLogin={handleLogin} />
      </>
    )
  }

  return (
    <>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 5000,
          style: { background: '#363636', color: '#fff' },
          success: { style: { background: '#10b981' } },
          error: { style: { background: '#ef4444' } }
        }}
      />
      
      <Router>
        <div className="min-h-screen bg-gray-50 flex">
          {/* Sidebar */}
          <Sidebar 
            isCollapsed={sidebarCollapsed} 
            onToggle={toggleSidebar}
            onLogout={handleLogout}
          />
          
          {/* Main Content */}
          <main className={`flex-1 transition-all duration-300 ${
            sidebarCollapsed ? 'ml-0' : 'ml-0'
          }`}>
            <Routes>
              <Route path="/" element={<DashboardGeral />} />
              <Route path="/crm" element={<CRMDashboard />} />
              <Route path="/insumos" element={<BaseInsumos />} />
              <Route path="/orcamentos" element={<Orcamentos />} />
              <Route path="/contratos" element={<Contratos />} />
              <Route path="/funcionarios" element={<Funcionarios />} />
              <Route path="/planejamento" element={<PlanejamentoObras />} />
              <Route path="/diario-obra" element={<DiarioObra />} />
              <Route path="/compras" element={<Compras />} />
              <Route path="/financeiro" element={<Financeiro />} />
              <Route path="/usuarios" element={<Usuarios />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
      </Router>
    </>
  )
}

export default App
